import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Enums } from '../../shared/models/enums';
import { ModalService } from '../../shared/services/modal.service';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { EditableTypes } from '../../shared/widgets/data-grid/enums/editable-types.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class AdminSettingsGridService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    constructor(private modalService: ModalService) { }


    fileNameCellRenderer(rowData) {
        return rowData.unreadNotification ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup"></i></span>` : '';
    }

    savingsCellRenderer(rowData, field) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    };

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData, field) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<div class="text-truncate" title="` + value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '';
        }

    }

    businessTargetCellRenderer(rowData, field) {
        const value = rowData[field];
        if (value != null && value !== '') {
            const num = Number(value);
            if (!isNaN(num)) {
                return num.toLocaleString(undefined, { maximumFractionDigits: 6 });
            }
        }
        return '';
    }


    cols: Array<TableColumn> = [
        {
            field: 'countryName',
            header: 'Country Name',
            sort: true,
            pinned: true,
            sortName: 'countryName',
            filter: { type: FilterTypes.text },
            style: { width: '220px', minWidth: '220px', maxWidth: '220px' }
        },
        {
            field: 'isPriority',
            header: 'Priority Country',
            sortName: 'isPriority',
            pinned: true,
            columnCheckBox: true,
            hideColumnHeaderCheckBox: true,      
            groupNameForCheckbox: 'isPriority',      
            isCheckBox: true,
            hideTextIfNotCellRenderer: true,
            style: { width: '130px', minWidth: '130px', maxWidth: '130px' }
        },
        {
            field: 'isASOP',
            header: 'ASOP Country',
            sortName: 'isASOP',
            pinned: true,
            columnCheckBox: true,
            hideColumnHeaderCheckBox: true,
            groupNameForCheckbox: 'isASOP',
            isCheckBox: true,
            hideTextIfNotCellRenderer: true,
            style: { width: '130px', minWidth: '130px', maxWidth: '130px' }
        },
        {
            field: 'isMAGC',
            header: 'MAGC Country',
            sortName: 'isMAGC',
            pinned: true,
            columnCheckBox: true,
            hideColumnHeaderCheckBox: true,
            groupNameForCheckbox: 'isMAGC',
            isCheckBox: true,
            hideTextIfNotCellRenderer: true,
            style: { width: '130px', minWidth: '130px', maxWidth: '130px' }
        },
        {
            field: 'canDelete',
            header: 'Delete',            
            displayName: ' ',
            pinned: true, 
            addOneLineSpaceIfSortDisable: true,
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' },
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDeleteCountryClick',
                elementsubType: CellRendererElementSubTypes.delete,
            }
        }
    ];
    colsTarget: Array<TableColumn> = [
        {
            field: 'countryName',
            header: 'Country Name',
            sort: true,
            sortName: 'countryName',
            filter: { type: FilterTypes.text },
            style: { width: '220px', minWidth: '220px', maxWidth: '220px' }
        },
        {
            field: 'fy',
            header: 'Fiscal Year',
            sort: true,
            sortName: 'fy',
            style: { width: '160px', minWidth: '160px', maxWidth: '160px' }
        },
        {
            field: 'ipTargetsRegistrations',
            header: 'IP Targets – Registrations (000s m2)',
            sort: true,
            sortName: 'ipTargetsRegistrations',
            editable: { type: EditableTypes.decimal, maxlength: 20, decimalPlaces: 6 },
            style: { width: '260px', minWidth: '260px', maxWidth: '260px' },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.businessTargetCellRenderer
            }
        },
        {
            field: 'targetValue',
            header: 'IP Targets – At Least Prelim Certification (000s m2)',
            sort: true,
            sortName: 'targetValue',
            editable: { type: EditableTypes.decimal, maxlength: 20, decimalPlaces: 6 },
            style: { width: '260px', minWidth: '260px', maxWidth: '260px' },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.businessTargetCellRenderer
            }
        },
        {
            field: 'stretchTargetsRegistrations',
            header: 'Stretch Targets – Registrations (000s m2)',
            sort: true,
            sortName: 'stretchTargetsRegistrations',
            editable: { type: EditableTypes.decimal, maxlength: 20, decimalPlaces: 6 },
            style: { width: '260px', minWidth: '260px', maxWidth: '260px' },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.businessTargetCellRenderer
            }
        },
        {
            field: 'stretchTargetsPrelimCert',
            header: 'Stretch Targets – At Least Prelim Certification (000s m2)',
            sort: true,
            sortName: 'stretchTargetsPrelimCert',
            editable: { type: EditableTypes.decimal, maxlength: 20, decimalPlaces: 6 },
            style: { width: '260px', minWidth: '260px', maxWidth: '260px' },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.businessTargetCellRenderer
            }
        }
    ];
}

